import React from "react";

export const ScenarioContext = React.createContext();